import { render, staticRenderFns } from "./configureCharts.vue?vue&type=template&id=18229d99&scoped=true"
import script from "./configureCharts.vue?vue&type=script&lang=js"
export * from "./configureCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18229d99",
  null
  
)

export default component.exports